export default __webpack_public_path__ + "static/media/contact_ostrihonova.5c94efec.jpg";